import { Button, Form, FormGroup, Modal } from "react-bootstrap";
import { NumberFormat } from "components/Common/NumberFormat/NumberFormat";
import { checkProduct } from "src/utils/storage/product";
import { useGetTotalNxacList } from "src/hooks/api/nxac/useGetTotalNxacList";
import { useUserNxacList } from "src/hooks/api/nxac/useUserNxacList";
import { useState } from "react";
import { useRouter } from "src/hooks/useRouter";
import { dateFormatUtcToYMD } from "src/utils/dateManagement";
import { localStrings } from "src/utils/localization";
import { PayPalButton } from "react-paypal-button-v2";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { IPayPlanInfo } from "src/config/priceTypeList";
import { useRecoilState } from "recoil";
import { productKeyAtom } from "src/atoms";
import useBillStatement from "src/hooks/Modal/Bill/useBillStatement";
import { useTranslation } from "react-i18next";

interface IChangePriceTypeModalProps {
  modal: any;
  toggleModalConfirmPrice: () => void;
  priceType: string;
  changePriceType: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  serviceList: any;
  payPlanInfo: IPayPlanInfo | any;
  driveUserPerPriceYear: any;
  driveUserPerPrice: any;
  basicUserPerPriceYear: number;
  basicUserPerPrice: any;
  basicPlusUserPerPrice: any;
  plusUserPerPriceYear: any;
  plusUserPerPrice: any;
  plusPlusUserPerPrice: any;

  isCheckPromotionCode: any;
  payTerm: any;
  licenseCount: any;
  changeLicenseCount: any;
  changePrice: any;
  changeNextPayDate: any;
  payCompany: any;
  changePriceIncTax: any;
  confirmPrice: (orderId: any, type: any, authorizationID: any) => void;
  toggleModalCheckConfirmPrice: () => void;
  promotionCode: any;
  promotionApply: () => void;
}
// 요금제 변경 모달 (추후 다시 만들 것!!!)
const ChangePriceTypeModal = ({
  modal,
  toggleModalConfirmPrice,
  priceType = "basic",
  changePriceType,
  handleChange,
  serviceList,
  payPlanInfo,

  // driveUserPerPriceYear,
  // driveUserPerPrice,
  // basicUserPerPriceYear,
  // basicUserPerPrice,
  // basicPlusUserPerPrice,
  // plusUserPerPriceYear,
  // plusUserPerPrice,
  // plusPlusUserPerPrice,

  isCheckPromotionCode,
  payTerm,
  licenseCount,
  changeLicenseCount,
  changePrice,
  changeNextPayDate,
  payCompany,
  changePriceIncTax,
  confirmPrice,
  toggleModalCheckConfirmPrice,
  promotionCode,
  promotionApply,
}: // goPrint,
IChangePriceTypeModalProps) => {
  const checkProductName = checkProduct("WRAPSODY_ECO");
  const [selectAppList, setSelectAppList] = useState<string[]>([]);
  const route = useRouter();
  const { nxacList } = useGetTotalNxacList({});
  const { checkNxacList } = useUserNxacList({});
  const [productKey, setProductName] = useRecoilState(productKeyAtom);
  const goPromotion = () => {
    route.goSitePromotion({ type: "ask" });
  };
  const { t } = useTranslation();
  const lang = route.lang;
  // const payPlan = payPlanInfo[productKey];

  const driveUserPerPriceYear = 0; // payPlan?.drive["ko"]?.year ??
  const driveUserPerPrice = 0; // payPlan?.drive["ko"]?.month ??
  const basicUserPerPriceYear = 0; // payPlan?.basic["ko"]?.year ??
  const basicUserPerPrice = 0; // payPlan?.basic["ko"]?.month ??
  const plusUserPerPriceYear = 0; // payPlan?.plus["ko"]?.year ??
  const plusUserPerPrice = 0; // payPlan?.plus["ko"]?.month ??
  const plusPlusUserPerPrice = 0; // payPlan?.plusPlus["ko"]?.month ??
  const basicPlusUserPerPrice = 0; // payPlan?.basicPlus["ko"]?.month ??
  const { payInfoModalState, togglePayInfoModal } = useBillStatement();

  return (
    <>
      <Modal
        show={payInfoModalState?.priceType}
        onHide={() => togglePayInfoModal({ info: "priceType" })}
        className="confirm__period confirm__period2"
        style={{ opacity: 1 }}
      >
        {/* 요금제 변경 모달 */}
        <Modal.Header closeButton>
          <h4>
            {t("siteManagement.paymentHistory.popUp.changeSiteType.title")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <FormGroup className="mg mb-0">
            {/* Drive 요금제*/}
            {getProductFromSessionStorage() === "WRAPSODY" && (
              <Form.Check className={`box box__gray mg mt-0 mb-16 radio`}>
                <Form.Check.Label>
                  <Form.Check.Input
                    type={"radio"}
                    name="changePriceType"
                    value={"drive"}
                    onChange={handleChange}
                    checked={changePriceType === "drive"}
                    disabled={
                      priceType === "basic" ||
                      priceType === "plus" ||
                      priceType === "plusPlus" ||
                      priceType === "basicPlus" ||
                      priceType === "promotion"
                    }
                  />
                  <span className="item__left3">
                    {/* <b>{t('subscriptionType.type.basic')}</b> */}
                    <b>{!checkProductName ? "Basic" : ""}</b>
                  </span>

                  <span className="item__left2 text weight--500">
                    {priceType !== ""
                      ? t("siteType.basic.detail.plan.price_condition_per_user")
                      : ""}
                    <NumberFormat
                      num={
                        serviceList[0]?.payTerm === "year"
                          ? driveUserPerPriceYear
                          : driveUserPerPrice
                      }
                      currency={serviceList[0]?.currency}
                    />
                    {priceType !== ""
                      ? t("siteType.basic.detail.plan.price_condition_monthly")
                      : ""}
                    <br />
                    <span className="text weight--350">
                      {priceType !== ""
                        ? t("siteType.basic.detail.plan.annual_sum")
                        : ""}
                      &nbsp;
                      <NumberFormat
                        num={
                          serviceList[0]?.payTerm === "year"
                            ? driveUserPerPriceYear * 12
                            : driveUserPerPrice * 12
                        }
                        currency={serviceList[0]?.currency}
                      />
                    </span>
                  </span>
                </Form.Check.Label>
              </Form.Check>
            )}
            {/* Standard / Basic 요금제*/}
            <Form.Check className="box box__gray mg mt-0 mb-16 radio disable">
              <Form.Check.Label>
                <Form.Check.Input
                  type={"radio"}
                  name="changePriceType"
                  value={"basic"}
                  onChange={handleChange}
                  checked={changePriceType === "basic"}
                  disabled={
                    priceType === "plus" ||
                    priceType === "plusPlus" ||
                    priceType === "basicPlus" ||
                    priceType === "promotion"
                  }
                />
                <span className="item__left3">
                  {/* <b>{t('subscriptionType.type.basic')}</b> */}
                  <b>{!checkProductName ? "Standard" : "Basic"}</b>
                </span>

                <span className="item__left2 text weight--500">
                  {priceType !== ""
                    ? t("siteType.basic.detail.plan.price_condition_per_user")
                    : ""}
                  <NumberFormat
                    num={
                      serviceList[0]?.payTerm === "year"
                        ? basicUserPerPriceYear
                        : basicUserPerPrice
                    }
                    currency={serviceList[0]?.currency}
                  />
                  {priceType !== ""
                    ? t("siteType.basic.detail.plan.price_condition_monthly")
                    : ""}
                  <br />
                  <span className="text weight--350">
                    {priceType !== ""
                      ? t("siteType.basic.detail.plan.annual_sum")
                      : ""}
                    &nbsp;
                    <NumberFormat
                      num={
                        serviceList[0]?.payTerm === "year"
                          ? basicUserPerPriceYear * 12
                          : basicUserPerPrice * 12
                      }
                      currency={serviceList[0]?.currency}
                    />
                  </span>
                </span>
              </Form.Check.Label>
            </Form.Check>

            {/* Enterprise / Plus 요금제*/}
            <Form.Check
              className="box box__gray mg mt-0 mb-16 radio"
              style={{ display: "flex", alignItems: "center" }}
            >
              <Form.Check.Label>
                <Form.Check.Input
                  type={"radio"}
                  name="changePriceType"
                  value="plus"
                  onChange={handleChange}
                  checked={changePriceType === "plus"}
                  disabled={
                    priceType === "basic" ||
                    priceType === "plusPlus" ||
                    priceType === "basicPlus"
                  }
                />
                <span className="item__left3">
                  <b>
                    {checkProductName
                      ? t("subscriptionType.type.plus")
                      : "Enterprise"}
                  </b>
                </span>
                <span
                  className="item__left2 text weight--500"
                  //style={{ minWidth: '150px' }}
                >
                  {priceType !== ""
                    ? t("siteType.basic.detail.plan.price_condition_per_user")
                    : ""}
                  <NumberFormat
                    num={
                      serviceList[0]?.payTerm === "year"
                        ? plusUserPerPriceYear
                        : plusUserPerPrice
                    }
                    currency={serviceList[0]?.currency}
                  />
                  {priceType !== ""
                    ? t("siteType.basic.detail.plan.price_condition_monthly")
                    : ""}
                  <br />
                  <span className="text weight--350">
                    {priceType !== ""
                      ? t("siteType.basic.detail.plan.annual_sum")
                      : ""}
                    &nbsp;
                    <NumberFormat
                      num={
                        serviceList[0]?.payTerm === "year"
                          ? plusUserPerPriceYear * 12
                          : plusUserPerPrice * 12
                      }
                      currency={serviceList[0]?.currency}
                    />
                  </span>
                </span>
              </Form.Check.Label>
              {changePriceType === "plus" && checkProductName && (
                <div
                  style={{
                    width: "200px",
                    height: "70px",
                    overflowY: "scroll",
                    marginLeft: "auto",
                  }}
                >
                  {checkNxacList.length > 0 && priceType === "plus" ? (
                    <div
                      style={{
                        //display: 'flex',
                        alignContent: "center",
                        //flexWrap: "wrap"
                      }}
                    >
                      <div>{t("admin.upc.site.selectedApp")}:</div>
                      {checkNxacList.map((item: any, index: number) => {
                        return (
                          <div className="ellipsisText">
                            {"- " + item.applicationName}
                          </div>
                        );
                      })}
                    </div>
                  ) : priceType === "plusPlus" ? (
                    <div></div>
                  ) : (
                    nxacList?.map((item: any, index: number) => {
                      return (
                        <div style={{ display: "flex" }}>
                          <input
                            type="checkbox"
                            name="selectAppList"
                            id={"selectAppList_" + item.nxacAppUid}
                            value={item.nxacAppUid}
                            checked={
                              selectAppList.indexOf(item.nxacAppUid) !== -1
                            }
                            onChange={handleChange}
                          />
                          <label
                            htmlFor={"selectAppList_" + item.nxacAppUid}
                            // className={`form-input-label ${
                            //   lang === 'ko'
                            //     ? ''
                            //     : 'mg ml-24'
                            // } ellipsisText`}
                            className={"form-input-label ellipsisText"}
                          >
                            {item.applicationName}
                          </label>
                        </div>
                      );
                    })
                  )}
                </div>
              )}
            </Form.Check>

            {/* Promotion 요금제*/}
            <Form.Check
              className="box box__gray2 mg mt-0 mb-16 radio"
              style={{ display: "flex", alignItems: "center" }}
            >
              <Form.Check.Label>
                <Form.Check.Input
                  type={"radio"}
                  name="changePriceType"
                  value="promotion"
                  onChange={handleChange}
                  checked={changePriceType === "promotion"}
                />
                <span
                  className={`
            ${isCheckPromotionCode === "FAIL" ? "item__left4" : "item__left3"}`}
                >
                  <b>{t("subscriptionType.type.premium")}</b>
                </span>
                <div
                  className={`
            ${isCheckPromotionCode === "FAIL" ? "item__left4" : "item__left3"}`}
                >
                  <input
                    type="text"
                    id="promotionCode"
                    name="promotionCode"
                    value={promotionCode}
                    onChange={handleChange}
                    maxLength={60}
                    disabled={changePriceType !== "promotion"}
                    className={` inline-block form-control custom-form width w-180 mg mr-10
            ${
              isCheckPromotionCode === "OK"
                ? "form-textbox-valid"
                : isCheckPromotionCode === "FAIL"
                ? "form-textbox-invalid"
                : ""
            }`}
                  />
                  <button
                    type="button"
                    onClick={promotionApply}
                    disabled={changePriceType !== "promotion"}
                    className=" inline-block btn buttonH40"
                  >
                    {t("siteType.premium.detail.plan.registerBtn")}
                  </button>
                  <br />
                  <span
                    className={`text text--orange text left ${
                      isCheckPromotionCode === "FAIL" ? "block" : "none"
                    }`}
                  >
                    {t("siteType.premium.detail.plan.invalidPromotionCode")}
                  </span>
                </div>
              </Form.Check.Label>
              {changePriceType === "promotion" && (
                <div
                  style={{
                    width: "200px",
                    height: "70px",
                    overflowY: "scroll",
                    marginLeft: "auto",
                  }}
                >
                  {checkNxacList.length > 0 && priceType === "promotion" ? (
                    <div
                      style={{
                        //display: "flex",
                        alignContent: "center",
                        //flexWrap: "wrap"
                      }}
                    >
                      <div>{t("admin.upc.site.selectedApp")}:</div>
                      {checkNxacList?.map((item: any, index: number) => {
                        return (
                          <div className="ellipsisText">
                            {"- " + item.applicationName}
                          </div>
                        );
                      })}
                    </div>
                  ) : priceType === "promotion" ? (
                    <div></div>
                  ) : (
                    nxacList?.map((item: any, index: number) => {
                      return (
                        <div style={{ display: "flex" }}>
                          <input
                            type="checkbox"
                            name="selectAppList"
                            id={"selectAppList_" + item.nxacAppUid}
                            value={item.nxacAppUid}
                            checked={
                              selectAppList.indexOf(item.nxacAppUid) !== -1
                            }
                            onChange={(e) => handleChange(e)}
                          />
                          <label
                            htmlFor={"selectAppList_" + item.nxacAppUid}
                            className={"form-input-label ellipsisText"}
                          >
                            {item.applicationName}
                          </label>
                        </div>
                      );
                    })
                  )}
                </div>
              )}
            </Form.Check>

            {/* 프로모션 요금제 결제 안내  */}
            {changePriceType === "promotion" ? (
              <div>
                <p className="text text--green text--13">
                  <span
                    onClick={() => goPromotion()}
                    className="cursor-pointer"
                  >
                    {t("siteType.premium.detail.plan.dontHaveCode")}
                  </span>
                </p>
                <p className="text text--gray text--13">
                  <span>
                    {t(
                      "siteManagement.paymentHistory.popUp.changeSiteType.toPremium.info.Msg1"
                    )}
                  </span>
                </p>
              </div>
            ) : priceType !== "basic" && changePriceType !== "promotion" ? (
              <p className="text text--black text--13">
                <span>
                  {t("siteManagement.paymentHistory.popUp.changeSiteType.Msg1")}
                </span>
                <a
                  className="text underline"
                  href={`https://www.wrapsody.com/${
                    navigator.language.includes("ko") ? "kr" : "en"
                  }/inquiry`}
                  target="_blank"
                >
                  {t("siteManagement.paymentHistory.popUp.changeSiteType.Msg2")}
                </a>
                <span>
                  {t("siteManagement.paymentHistory.popUp.changeSiteType.Msg3")}
                </span>
              </p>
            ) : (
              ""
            )}
            {/* {changePriceType === 'promotion' ? (
            <p className="text text--gray text--13">
              <span>
                {t(
                  'siteManagement.paymentHistory.popUp.changeSiteType.toPremium.info.Msg1'
                )}
              </span>
            </p>
          ) : (
            ''
          )} */}

            {/* 결제 주기 */}
            {(priceType !== "plus" && changePriceType === "plus") ||
            (priceType !== "plusPlus" && changePriceType === "plusPlus") ||
            (priceType !== "basicPlus" && changePriceType === "basicPlus") ? (
              <p className="text text--gray text--13">
                {payTerm === "year" ? (
                  <span>
                    {checkProductName
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.annual.Msg1"
                        )
                      : t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.annual.Msg1"
                        )}
                    <br />
                    {checkProductName
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.annual.Msg2",
                          {
                            0: licenseCount.toLocaleString(),
                          }
                        )
                      : t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.annual.Msg2",
                          {
                            0: licenseCount.toLocaleString(),
                          }
                        )}
                    <br />
                    {checkProductName
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.annual.Msg3",
                          {
                            0: changePrice.toLocaleString(),
                          }
                        )
                      : t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.annual.Msg3",
                          {
                            0: changePrice.toLocaleString(),
                          }
                        )}
                    <br />
                    {changePrice === "plus"
                      ? checkProductName
                        ? t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.annual.Msg3_1",
                            {
                              0: changePrice.toLocaleString(),
                            }
                          )
                        : t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                              (lang === "ko" ? "KRW." : "USD.") +
                              "info.annual.Msg3_1",
                            {
                              0: changePrice.toLocaleString(),
                            }
                          )
                      : changePriceType === "plusPlus"
                      ? t(
                          (priceType === "plus"
                            ? "siteManagement.paymentHistory.popUp.changeSiteType.plusToplusPlus."
                            : "siteManagement.paymentHistory.popUp.changeSiteType.basicToplusPlus.") +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.annual.Msg3_1",
                          {
                            0: changePrice.toLocaleString(),
                          } //+ " 문구 수정 필요!!!!"
                        )
                      : changePriceType === "basicPlus"
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicTobasicPlus." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.annual.Msg3_1",
                          {
                            0: changePrice.toLocaleString(),
                          } //+ " 문구 수정 필요!!!!"
                        )
                      : ""}
                    <br />
                    {changePrice === "plus"
                      ? checkProductName
                        ? t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.annual.Msg4",
                            {
                              0: dateFormatUtcToYMD(changeNextPayDate),
                              1: (
                                Number(plusUserPerPrice) *
                                (Number(changeLicenseCount) +
                                  Number(licenseCount)) *
                                10
                              ).toLocaleString(),
                              2: lang === "ko" ? "₩" : "$",
                            }
                          )
                        : t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                              (lang === "ko" ? "KRW." : "USD.") +
                              "info.annual.Msg4",
                            {
                              0: dateFormatUtcToYMD(changeNextPayDate),
                              1: (
                                Number(plusUserPerPrice) *
                                (Number(changeLicenseCount) +
                                  Number(licenseCount)) *
                                10
                              ).toLocaleString(),
                              2: lang === "ko" ? "₩" : "$",
                            }
                          )
                      : changePriceType === "plusPlus"
                      ? t(
                          (priceType === "basic"
                            ? "siteManagement.paymentHistory.popUp.changeSiteType.basicToplusPlus."
                            : priceType === "basicPlus"
                            ? "siteManagement.paymentHistory.popUp.changeSiteType.basicPlusToplusPlus."
                            : //: priceType === "plus" ?
                              "siteManagement.paymentHistory.popUp.changeSiteType.plusToplusPlus.") +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.annual.Msg4",
                          {
                            0: dateFormatUtcToYMD(changeNextPayDate),
                            1: (
                              Number(plusUserPerPrice) *
                              (Number(changeLicenseCount) +
                                Number(licenseCount)) *
                              10
                            ).toLocaleString(),
                            2: lang === "ko" ? "₩" : "$",
                          }
                        )
                      : changePriceType === "basicPlus"
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicTobasicPlus." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.annual.Msg4",
                          {
                            0: dateFormatUtcToYMD(changeNextPayDate),
                            1: (
                              Number(plusUserPerPrice) *
                              (Number(changeLicenseCount) +
                                Number(licenseCount)) *
                              10
                            ).toLocaleString(),
                            2: lang === "ko" ? "₩" : "$",
                          }
                        )
                      : ""}
                    <br />
                    <br />
                    {checkProductName
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.annual.Msg5"
                        )
                      : t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.annual.Msg5"
                        )}
                  </span>
                ) : (
                  <span>
                    {changePriceType === "plus"
                      ? checkProductName
                        ? t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.monthly.Msg1"
                          )
                        : t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                              (lang === "ko" ? "KRW." : "USD.") +
                              "info.monthly.Msg1"
                          )
                      : changePriceType === "plusPlus"
                      ? t(
                          (priceType === "basic"
                            ? "siteManagement.paymentHistory.popUp.changeSiteType.basicToplusPlus."
                            : priceType === "basicPlus"
                            ? "siteManagement.paymentHistory.popUp.changeSiteType.basicPlusToplusPlus."
                            : "siteManagement.paymentHistory.popUp.changeSiteType.plusToplusPlus.") +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.monthly.Msg1"
                        ) // + " 수정11"
                      : changePriceType === "basicPlus"
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicTobasicPlus." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.monthly.Msg1"
                        ) // + " 수정11"
                      : ""}
                    <br />
                    {changePriceType === "plus"
                      ? checkProductName
                        ? t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.monthly.Msg2",
                            {
                              0: licenseCount,
                            }
                          )
                        : t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                              (lang === "ko" ? "KRW." : "USD.") +
                              "info.monthly.Msg2",
                            {
                              0: licenseCount,
                            }
                          )
                      : changePriceType === "plusPlus"
                      ? t(
                          (priceType === "basic"
                            ? "siteManagement.paymentHistory.popUp.changeSiteType.basicToplusPlus."
                            : priceType === "basicPlus"
                            ? "siteManagement.paymentHistory.popUp.changeSiteType.basicPlusToplusPlus."
                            : "siteManagement.paymentHistory.popUp.changeSiteType.plusToplusPlus.") +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.monthly.Msg2",
                          {
                            0: licenseCount,
                          }
                        ) //+ " 수정22"
                      : changePriceType === "basicPlus"
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicTobasicPlus." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.monthly.Msg2",
                          {
                            0: licenseCount,
                          }
                        ) // + " 수정22"
                      : ""}
                    <br />
                    {changePriceType === "plus"
                      ? checkProductName
                        ? t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.monthly.Msg3_1",
                            {
                              0: changePrice.toLocaleString(),
                            }
                          )
                        : t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                              (lang === "ko" ? "KRW." : "USD.") +
                              "info.monthly.Msg3_1",
                            {
                              0: changePrice.toLocaleString(),
                            }
                          )
                      : changePriceType === "plusPlus"
                      ? t(
                          (priceType === "basic"
                            ? "siteManagement.paymentHistory.popUp.changeSiteType.basicToplusPlus."
                            : priceType === "basicPlus"
                            ? "siteManagement.paymentHistory.popUp.changeSiteType.basicPlusToplusPlus."
                            : "siteManagement.paymentHistory.popUp.changeSiteType.plusToplusPlus.") +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.monthly.Msg3_1",
                          {
                            0: changePrice.toLocaleString(),
                          }
                        ) // + " 수정33"
                      : changePriceType === "basicPlus"
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicTobasicPlus." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.monthly.Msg3_1",
                          {
                            0: changePrice.toLocaleString(),
                          }
                        ) //+ " 수정33"
                      : ""}
                    <br />
                    {changePriceType === "plus"
                      ? checkProductName
                        ? t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.monthly.Msg4",
                            {
                              0: dateFormatUtcToYMD(changeNextPayDate),
                              1: (
                                Number(plusUserPerPrice) *
                                (Number(changeLicenseCount) +
                                  Number(licenseCount))
                              ).toLocaleString(),

                              2: lang === "ko" ? "₩" : "$",
                            }
                          )
                        : t(
                            "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                              (lang === "ko" ? "KRW." : "USD.") +
                              "info.monthly.Msg4",
                            {
                              0: dateFormatUtcToYMD(changeNextPayDate),
                              1: (
                                Number(plusUserPerPrice) *
                                (Number(changeLicenseCount) +
                                  Number(licenseCount))
                              ).toLocaleString(),
                              2: lang === "ko" ? "₩" : "$",
                            }
                          )
                      : changePriceType === "plusPlus"
                      ? t(
                          (priceType === "basic"
                            ? "siteManagement.paymentHistory.popUp.changeSiteType.basicToplusPlus."
                            : priceType === "basicPlus"
                            ? "siteManagement.paymentHistory.popUp.changeSiteType.basicPlusToplusPlus."
                            : "siteManagement.paymentHistory.popUp.changeSiteType.plusToplusPlus.") +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.monthly.Msg4",
                          {
                            0: dateFormatUtcToYMD(changeNextPayDate),
                            1: (
                              Number(plusPlusUserPerPrice) *
                              (Number(changeLicenseCount) +
                                Number(licenseCount))
                            ).toLocaleString(),
                            2: lang === "ko" ? "₩" : "$",
                          }
                        )
                      : changePriceType === "basicPlus"
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicTobasicPlus." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.monthly.Msg4",
                          {
                            0: dateFormatUtcToYMD(changeNextPayDate),
                            1: (
                              Number(basicPlusUserPerPrice) *
                              (Number(changeLicenseCount) +
                                Number(licenseCount))
                            ).toLocaleString(),
                            2: lang === "ko" ? "₩" : "$",
                          }
                        )
                      : ""}
                    <br />

                    <br />
                    {checkProductName
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.monthly.Msg3",
                          {
                            0: changePrice.toLocaleString(),
                            1: lang === "ko" ? "KRW" : "USD",
                          }
                        )
                      : t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.monthly.Msg3",
                          {
                            0: changePrice.toLocaleString(),
                            1: lang === "ko" ? "KRW" : "USD",
                          }
                        )}
                    <br />
                    {checkProductName
                      ? t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.eco.info.monthly.Msg5"
                        )
                      : t(
                          "siteManagement.paymentHistory.popUp.changeSiteType.basicToPlus.wrapsody." +
                            (lang === "ko" ? "KRW." : "USD.") +
                            "info.monthly.Msg5"
                        )}
                  </span>
                )}

                {lang !== "ko" ? (
                  <span className="flex flex-wrap">
                    <input
                      type="checkbox"
                      name="checkPay"
                      id="checkPay"
                      onChange={handleChange}
                    />
                    <label
                      className="inputArea-label"
                      htmlFor="checkPay"
                    ></label>
                    <label className="text text--black">
                      {t(
                        "siteManagement.paymentHistory.popUp.changeNumberOfUsers.Msg4"
                      )}
                    </label>
                  </span>
                ) : (
                  ""
                )}
              </p>
            ) : (
              ""
            )}
          </FormGroup>
        </Modal.Body>

        {changePrice > 0 ? (
          payCompany === "PAYPAL" ? (
            <Modal.Footer>
              <PayPalButton
                createOrder={(data: any, actions: any) => {
                  return actions.order.create({
                    purchase_units: [
                      {
                        amount: {
                          value: changePriceIncTax,
                        },
                      },
                    ],
                  });
                }}
                onApprove={(data: any, actions: any) => {
                  // Capture the funds from the transaction
                  return actions.order
                    .authorize()
                    .then(function (authorization: any) {
                      // Show a success message to your buyer
                      confirmPrice(
                        data.orderID,
                        "user",
                        authorization.purchase_units[0].payments
                          .authorizations[0].id
                      );
                    });
                }}
              />
            </Modal.Footer>
          ) : (
            <Modal.Footer>
              <Button
                className={"btn btn-green btn-40 width w-100p pd py-10"}
                onClick={toggleModalCheckConfirmPrice}
              >
                {/* <img
              className="card mg mr-10"
              src="/resources/images/card.png"
              alt=""
            ></img> */}
                {/* 체크카드 및 신용카드 */}
                {t("common.card")}
              </Button>
            </Modal.Footer>
          )
        ) : (
          ""
        )}
      </Modal>
    </>
  );
};

export default ChangePriceTypeModal;
